import { Component, OnInit } from '@angular/core';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { ReportRegistryService } from 'src/app/services/report/report-registry.service';


@Component({
  selector: 'app-all-report',
  templateUrl: './all-report.component.html',
  styleUrls: ['./all-report.component.css']
})
export class AllReportComponent implements OnInit {
  registry_reports_are_loaded: boolean = false;

  constructor(
    private performRepSrv: PerformanceReportService,
    public report_registry: ReportRegistryService,
  ) {
    this.report_registry.is_loaded.subscribe(is_loaded => {
      this.registry_reports_are_loaded = is_loaded;
    });

  }

  ngOnInit() {
  }




}
